import React, { Component } from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { PrimaryButton, SecondaryButton, InputText, LabelString } from "@loanbossinc/component-library";
import TypeAheadDropdown from "components/Global/Fields/TypeAheadDropdown";
import styled from "styled-components";

const StyledDialogIconButton = styled(IconButton)`&& {
    position: absolute;
    top: 8px;
    right: 13px;
}`;

const StyledDialogContent = styled(DialogContent)`&& {
    display: flex;
    flex-direction: column;
    padding-right: 60px;
    color: #666;
    gap: 1em;
}`;

const FieldWrapper = styled.div`&& {
    display: flex;
    flex-direction: column;
}`;

const StyledDialogTitle = styled(DialogTitle)`&& {
    width: 550px;
}`;

const StyledLabelString = styled(LabelString)`&& {
    margin-right: 26px;
    margin-top: auto;
    margin-bottom: auto;
}`;

const StyledInputText = styled(InputText)`&& {
    width: 100%;
}`;

const StyledTypeAheadDropdown = styled(TypeAheadDropdown)`&& {
    width: 514px;
    border: 1px solid #DADCE0;
    border-radius: 4px;
    && > div > div > div > div > p {
        left: 6px;
    }
    && > div > div > div > div > div {
        margin-left: 6px;
    }
}`;

export class UpsertModal extends Component {
  render() {
    const { title, content, isOpen, onClose, onAccept, onChange, onSystemActionChange, systemActionOptions } = this.props;
    if (!content) {
      return null;
    }

    return (
      <Dialog open={isOpen} onClose={onClose}>
        <StyledDialogTitle className="StyledDialogTitle">{title}</StyledDialogTitle>
        <StyledDialogIconButton onClick={onClose}>
          <CloseIcon id="closeIcon" style={{ fontSize: 22 }} />
        </StyledDialogIconButton>
        <StyledDialogContent className="StyledDialogContent">

          <FieldWrapper className="FieldWrapper">
            <StyledLabelString value={"Document Name"} />
            <StyledInputText
              placeholder="Value"
              onChange={onChange}
              value={content.value}
              variant="filled"
            />
          </FieldWrapper>
          <FieldWrapper>
            <StyledLabelString value="Task Action" />
            <StyledTypeAheadDropdown
              name="financialReportingSystemActionDropdown"
              label="Task Action"
              placeholder="Task Action"
              value={content?.systemAction}
              options={systemActionOptions}
              handleChange={selectedItem => onSystemActionChange(selectedItem)}
              shouldShow
              usingFormik={false}
            />
          </FieldWrapper>

        </StyledDialogContent>
        <DialogActions className="DialogActions">
          {onClose && <SecondaryButton size={"sm"} onClick={onClose} label="Cancel" style={{ "margin-right": "16px" }} />}
          <PrimaryButton size={"sm"} onClick={onAccept} label="OK" />
        </DialogActions>
      </Dialog>
    );
  }
}
